// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1lzyi","question":"Question_question__1P7oP","description":"Question_description__2GQxp"};